module.exports = __webpack_public_path__ + "img/estrella.da8e64d3.svg";